// extracted by mini-css-extract-plugin
module.exports = {"homepageContainer":"Home_homepageContainer__3xjoD","skeleton-loading":"Home_skeleton-loading__kkmI7"};